import { ViewModel } from '../view-model';
import { PlannedMaintenanceActivity } from './planned-maintenance';

export class UserAcceptancePlannedMaintenance implements ViewModel {
  friendlyTypeNameSingular: string = 'User Acceptance Planned Maintenance';
  apiRoute: string = null;

  id: string;
  reference: string;
  activity: PlannedMaintenanceActivity;

  json() {
    return this;
  }

  loadFromJson(data: any) {
    this.id = data.id;
    this.reference = data.reference;
    this.activity = data.activity;
  }
}
